import React, {useState, useEffect} from 'react';
import Text from '../Formatting/Text';
import { useAssistantContext } from './Provider';
import Button from '../Button/Button';
import { useToasts } from '../Toasts';


const recognitionAvailable = !!(window.webkitSpeechRecognition || window.SpeechRecognition);
let recognition;
if (recognitionAvailable) {
    recognition = window.webkitSpeechRecognition ?
        new window.webkitSpeechRecognition() :
        new window.SpeechRecognition();
    recognition.lang = "en-GB";
    recognition.interimResults = true;
}

const Panel = ({mobile}) => {
    const {assistantOpen, setAssistantOpen, text} = useAssistantContext();
    const [dictating, setDictating] = useState(false);
    const [tmpQuestion, setTmpQuestion] = useState('');
    const {showError} = useToasts();

    useEffect(() => {
        if (!recognitionAvailable) {
            return;
        }

        const onResult = (event) => setTmpQuestion(event.results[0][0].transcript);
        const onSpeechEnd = () => stopDictating();

        const onError = (event) => {
            console.error(event);
            setDictating(false);
            recognition.stop();
            showError(`Speech recognition error detected: ${event.error}`)
        }

        recognition.addEventListener('result', onResult);
        recognition.addEventListener('speechend', onSpeechEnd);
        recognition.addEventListener('error', onError);

        return () => {
            recognition.removeEventListener('result', onResult);
            recognition.removeEventListener('speechend', onSpeechEnd);
            recognition.removeEventListener('error', onError);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggleDictation = () => dictating ? stopDictating() : startDictating();

    const startDictating = () => {
        setDictating(true);
        recognition.start();
    }

    const stopDictating = () => {
        recognition.stop();
        setDictating(false);
        setTimeout(() => {
            handleSubmit();
        }, 500);
    }

    const handleSubmit = () => {
        console.log('Heard:', tmpQuestion);
    }

    if (!assistantOpen) {
        return null;
    }

    return <div id="assistant-panel" className="p-2 md:p-4 bg-brand text-white shadow-inner shadow-blue-900 rounded-t-md">
        <Text text={text} />
        <Text text={tmpQuestion} />
        <Button theme="light" onClick={toggleDictation} label="Dictation" />
        <Button theme="light" onClick={() => setAssistantOpen(false)} label="Close" />
    </div>
}

export default Panel;